import { render, staticRenderFns } from "./_base-place-holder.vue?vue&type=template&id=067d8011&"
import script from "./_base-place-holder.vue?vue&type=script&lang=ts&"
export * from "./_base-place-holder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports